import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { CUSTOMERS, CUSTOMER_ORDER, BACKGROUNDS, BACKGROUND_ORDER, bgSrc, salesmanSprite } from "@/lib/customers";
import { PixelSprite } from "@/components/game/PixelSprite";
import { selectCls } from "./QuestionEditor";

export const CustomerEditor = ({ quiz, sel, update, t, lang }) => {
  const c = quiz.customers[sel.c];
  const def = CUSTOMERS[c.type];
  const bg = bgSrc(c.background);
  const upd = (fn) => update((qz) => fn(qz.customers[sel.c]));
  const setType = (type) => upd((x) => {
    if (!x.name || x.name === CUSTOMERS[x.type].name) x.name = CUSTOMERS[type].name;
    x.type = type;
  });

  return (
    <div className="max-w-3xl mx-auto flex flex-col gap-7" data-testid="customer-editor">
      <div>
        <div className="text-xs uppercase tracking-wider font-bold text-muted-foreground">{t("customer_questions_count", { n: c.questions.length })}</div>
        <h2 className="text-2xl font-bold">{t("customer")} {sel.c + 1}</h2>
        <p className="text-sm text-muted-foreground mt-1">{t("customer_hint")}</p>
      </div>

      <div className="grid gap-2 max-w-sm">
        <Label>{t("customer_name")}</Label>
        <Input data-testid="customer-name-input" maxLength={24} value={c.name} onChange={(e) => upd((x) => { x.name = e.target.value; })} />
      </div>

      <div className="grid gap-3">
        <Label>{t("customer_type")}</Label>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3" data-testid="quiz-builder-customer-select">
          {CUSTOMER_ORDER.map((type) => (
            <button
              key={type}
              data-testid={`customer-type-${type}`}
              onClick={() => setType(type)}
              className={`rounded-lg border-2 p-2 flex flex-col items-center gap-1 transition-colors ${c.type === type ? "border-primary bg-primary/10" : "border-border hover:border-muted-foreground"}`}
            >
              <img src={CUSTOMERS[type].portrait} alt="" className="pixelated w-full aspect-square object-cover object-top rounded bg-slate-800" />
              <span className="text-[11px] font-semibold text-center leading-tight">{CUSTOMERS[type].label[lang]}</span>
            </button>
          ))}
        </div>
      </div>

      <div className="grid gap-2 max-w-sm">
        <Label>{t("background")}</Label>
        <select data-testid="customer-background-select" className={selectCls} value={c.background || "default"}
          onChange={(e) => upd((x) => { x.background = e.target.value; })}>
          {BACKGROUND_ORDER.map((k) => <option key={k} value={k}>{BACKGROUNDS[k].label[lang]}</option>)}
        </select>
      </div>

      <div className="grid sm:grid-cols-2 gap-4">
        <div className="rounded-xl border border-border overflow-hidden">
          <div className="text-xs font-bold uppercase tracking-wider px-3 py-2 bg-secondary/60">{t("sidescroller_view")}</div>
          <div className="relative h-56 overflow-hidden">
            <div className="store-bg" style={bg ? { backgroundImage: `url(${bg})` } : undefined} />
            <div className="absolute bottom-3 left-[18%]"><PixelSprite params={salesmanSprite(quiz.shirt_color)} height="150px" /></div>
            <div className="absolute bottom-3 left-[52%]"><PixelSprite params={def.sprite} height="150px" facing="left" walking testId="customer-preview-sprite" /></div>
          </div>
        </div>
        <div className="rounded-xl border border-border overflow-hidden">
          <div className="text-xs font-bold uppercase tracking-wider px-3 py-2 bg-secondary/60">{t("dialogue_view")}</div>
          <div className="relative h-56 overflow-hidden bg-slate-900">
            <div className="store-bg" style={{ filter: "brightness(0.45) blur(2px)", ...(bg ? { backgroundImage: `url(${bg})` } : {}) }} />
            <img src={def.portrait} alt="" className="pixelated absolute bottom-0 left-2 h-full" data-testid="customer-preview-portrait" />
            <div className="absolute right-3 bottom-3 px-box font-silk text-xs py-1.5 px-2.5">{c.name || "—"}</div>
          </div>
        </div>
      </div>
    </div>
  );
};
